/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-23 16:13:06
 * @LastEditors: bbq
 * @LastEditTime: 2020-09-01 20:31:12
 */
import { getSysFieldid } from '@platform/api';
/**
 *  enterkey使用
 * @desc 现在attrCode 名称中有 xxx.xx 的情况导致 查询dom 元素时 找不到的情况
 * @resolve 如果attrCode中存在.  xxx.xx -> xxx_xx
 * @param name
 * @return name
 */
export function processCodeClassName(name) {
    return name.indexOf('.') === -1
        ? name
        : name.replace(/\./g, '_');
}

export function getPublicAttribute(item, code, status) {
    let { attrcode = '', itemtype, isbold, canBeEditedWhenBrowse, columnStyle } = item;
    let className = `${processCodeClassName(attrcode)} js-type-${itemtype} form-item ${status === 'browse' ? ' form-item-browse' : ''} ${isbold ? 'form-item-highlight' : ''} ${columnStyle ? 'form-item-bg-highlight' : ''}`;
    let realBrowse = !['switch_browse', 'attachment'].includes(itemtype) && (status === 'browse' && !canBeEditedWhenBrowse);
    let fieldid = getSysFieldid(attrcode);
    let hotkeytag = `${code}-${attrcode}`;
    return { className, fieldid, hotkeytag, realBrowse };
}

export function toTree(list, key, parId) {
    let obj = {};
    let result = [];
    //将数组中数据转为键值对结构 (这里的数组和obj会相互引用)
    list.map(el => {
        obj[el[key]] = el;
    });
    for (let i = 0, len = list.length; i < len; i++) {
        let id = list[i].parentId;
        if (id == parId) {
            result.push(list[i]);
            continue;
        }
        if (obj[id].children) {
            obj[id].children.push(list[i]);
        } else {
            obj[id].children = [list[i]];
        }
    }
    return result;
}
//node.name === 'FormArea' && node.props.moduleId === formId
export function treeSearch(tree, callback) {
    let node; //结果
    let queue = [...tree]; //
    while (node = queue.shift()) {
        if (callback(node)) {break;}
        let children = node.children;
        if (Array.isArray(children)) {queue.push(...children);}
    }
    return node;
}

//在form组件的state中获取元素是否可见 enterkey使用
export function getVisibleStatusInStates({ visibleState, moduleId, attrCode }) {
    if (visibleState[moduleId]) {
        return visibleState[moduleId][attrCode] === false;
    } else {
        return visibleState[attrCode] === false;
    }
}

//  enterkey使用
export function itemIsDisable(disableState, item) {
    let { attrcode } = item;

    if (disableState[attrcode] !== true) {return false;}

    return disableState[attrcode] === true || item.disabled === true;
}

//  enterkey使用
export function itemIsVisible(visibleState, item, moduleId) {
    let { attrcode } = item;
    return getVisibleStatusInStates({ visibleState, moduleId, attrCode: attrcode }) || item.visible === false;
}

/**
 * 给编辑前使用
 * @param fields {array} 所有字段
 * @param disableFields {object} 不可聚焦啊字段
 * @param currentItem {object} 当前字段
 * @return {object}
 */
export function findFocusItem(fields, disableFields, currentItem) {
    let next = '',
        prev = '';

    fields.forEach((item, index) => {
        if (item == currentItem.attrcode) {
            let nextField = fields[index + 1];
            let prevField = fields[index - 1];
            next = disableFields[nextField] === true
                ? findNextFocusItem(fields.slice(index + 1), disableFields)
                : nextField;

            prev = disableFields[prevField] === true
                ? findPrevFocusItem(fields.slice(0, index - 1), disableFields)
                : prevField;
        }
    });

    return {
        next,
        prev,
    };
}

function findNextFocusItem(fields, disableFields) {
    return fields.find(item => {
        return disableFields[item] !== true;
    });
}

function findPrevFocusItem(fields, disableFields) {
    return fields.reverse().find(item => {
        return disableFields[item] !== true;
    });
}

export function getMainId(areaCode, meta) {
    let mainFormId = areaCode;
    if (meta?.corerelation) {
        for (const key in meta.corerelation) {
            if (Object.hasOwnProperty.call(meta.corerelation, key)) {
                const element = meta.corerelation[key];
                element?.includes(areaCode) && meta[key]?.moduletype === 'form' && (mainFormId = key);
            }
        }
    }
    // 有可能这里配的是表单分组id，需要根据 formrelation 找到主表id
    if (meta?.formrelation) {
        for (const key in meta.formrelation) {
            if (Object.hasOwnProperty.call(meta.formrelation, key)) {
                const element = meta.formrelation[key];
                element?.includes(mainFormId) && meta[key]?.moduletype === 'form' && (mainFormId = key);
            }
        }
    }
    // 还有一种情况，配置的是多页签表单 tabs其他tab，需要根据 formassociatedrelation 找到主表id
    if (meta?.formassociatedrelation) {
        for (const key in meta.formassociatedrelation) {
            if (Object.hasOwnProperty.call(meta.formassociatedrelation, key)) {
                const element = meta.formassociatedrelation[key]['formtabs'];
                element?.includes(mainFormId) && meta[key]?.moduletype === 'form' && (mainFormId = key);
            }
        }
    }
    return mainFormId;
}